import { useRef, useEffect, useState, Fragment } from "react";
import ReactSignatureCanvas from "react-signature-canvas";
import { FormattedMessage as FM } from "react-intl";

import { TrashIcon } from "components/Icons";
import Dialog from "componentsv2/modal/Dialog";
import Button from "componentsv2/button/Button";
import { cn } from "tools/ui";

const Signature = ({
  onSave,
  label,
  model,
  name,
  value,
  className,
  disabled,
  disableMsg,
}) => {
  const [signatureImage, setSignatureImage] = useState(value ?? "");
  const [openModal, setOpenModal] = useState({ value: false });
  const signatureCanvasRef = useRef(null);

  useEffect(() => {
    if (value) {
      const isBase64Full = value.startsWith("data:image");
      const fixedValue = isBase64Full
        ? value
        : `data:image/png;base64,${value}`;
      setSignatureImage(fixedValue);
    } else {
      setSignatureImage("");
    }
  }, [value]);

  const clearSignature = () => {
    signatureCanvasRef.current?.clear();
    setOpenModal({ value: false });
  };

  const saveSignature = () => {
    if (signatureCanvasRef.current && !signatureCanvasRef.current.isEmpty()) {
      const dataUrl = signatureCanvasRef.current.toDataURL();
      const base64Data = dataUrl.replace(/^data:image\/\w+;base64,/, "");

      setSignatureImage(dataUrl);
      onSave?.({ name, image: base64Data });
      setOpenModal({ value: false });
    } else {
      console.error("Por favor firma antes de guardar.");
    }
  };

  function ButtonsActions() {
    return (
      <div className="flex space-x-[19px] w-full max-w-[327px] justify-center mx-auto pointer-events-auto">
        <Button
          color="rose"
          content="Cancelar"
          size="w-full"
          onClick={clearSignature}
        />
        <Button
          style="border-none"
          color="amber"
          content="Aceptar y Firmar"
          size="w-full"
          onClick={saveSignature}
        />
      </div>
    );
  }

  return (
    <Fragment>
      <div className={cn(`flex space-x-3 relative cursor-pointer`, className)}>
        {signatureImage && (
          <div className="absolute  right-2 bottom-2">
            <button
              className="text-red-600 underline"
              onClick={() => setSignatureImage("")}
            >
              <TrashIcon className="mr-auto h-6 w-6 my-auto fill-rose-400" />
              {/* <XMarkIcon className="w-10 h-10 cursor-pointer fill-current text-red-900 shadow-xl rounded-full hover:text-red-800 bg-rose-200 p-1 border border-rose-500" /> */}
            </button>
          </div>
        )}

        <div
          className="space-y-[12px] w-full bg-gray-100 rounded-2xl border border-dashed border-gratin-200 p-2 "
          onClick={() =>
            disabled ? disableMsg() : setOpenModal({ value: true })
          }
        >
          <div className="min-h-[100px] flex items-center justify-center border-b border-[#1f2837] border-dashed w-max mx-auto">
            {signatureImage ? (
              <img
                src={signatureImage}
                alt="Firma"
                className="object-contain max-h-[100px]"
              />
            ) : (
              <span className="text-gray-400 text-lg md:text-xl relative top-[25px]">
                <FM id="staff.supply.no_signature" />
              </span>
            )}
          </div>

          <div className="font-bold text-[18px] text-center text-[#1f2837]">
            <span>{label && <FM id={label} />}</span>
          </div>
        </div>
      </div>

      <Dialog
        openModal={openModal}
        handleClose={() => setOpenModal({ value: false })}
        style="!w-[500px] md:!h-[390px] h-fit"
        hiddenHeader={true}
      >
        <div className="flex flex-col justify-between items-stretch h-ful w-full md:pb-15 space-y-3">
          <div>
            <h2 className=" text-[#1f2837] text-[24px] font-bold w-full text-left">
              <FM id={label} />
            </h2>
            <div className="flex flex-col items-start justify-start w-full"></div>
          </div>

          <ReactSignatureCanvas
            ref={signatureCanvasRef}
            penColor="black"
            canvasProps={{
              width: 400,
              height: 200,
              className: "signature-canvas bg-gray-200 rounded-md",
            }}
          />

          <ButtonsActions />
        </div>
      </Dialog>
    </Fragment>
  );
};

export default Signature;
